import React, {useEffect, useState} from 'react';
import {Box, Button, CircularProgress, ImageList, ImageListItem, Pagination} from "@mui/material";
import CuttingMapCanvas from "./CuttingMapCanvas";

const CuttingImageGallery = ({
                                 images,
                                 isLoading,
                                 setOpenModalImageGallery,
                                 height,
                                 weight,
                                 buttonClose,
                                 currentPage,
                                 setCurrentPage,
                                 vectorMode = false,
                                 vectorCuttingMap = null,
                                 vectorPageCount = 0,
                                 drawEdge = true,
                                 drawPosition = true,
                                 onDetailHover,
                                 showRuler = false,
                                 rulerCoords = null,
                                 onRulerCoordsChange,
                                 rulerLocked = false,
                                 onRulerPinToggle,
                             }) => {

    const itemsPerPage = 1;
    const totalPages = vectorMode
        ? vectorPageCount
        : (images ? Math.ceil(images.length / itemsPerPage) : 0);
    const [displayedImages, setDisplayedImages] = useState(images ? images.slice(0, itemsPerPage) : []);

    useEffect(() => {
        if (vectorMode) {
            return;
        }
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        setDisplayedImages(images ? images.slice(startIndex, endIndex) : []);
    }, [currentPage, images, vectorMode]);

    const handlePageChange = (event, newPage) => {
        setCurrentPage(newPage);
    };

    const handleImageClick = () => {
        setOpenModalImageGallery(true);
    };

    const close = () => {
        setOpenModalImageGallery(false);
    };

    if (vectorMode) {
        return (
            <Box sx={{position: 'relative', width: '100%', height: '100%'}}>
                <Box
                    onClick={showRuler ? undefined : handleImageClick}
                    sx={{width: '100%', height: buttonClose ? '85vh' : '100%', bgcolor: '#fff'}}
                >
                    {vectorCuttingMap && !isLoading && (
                        <CuttingMapCanvas
                            cuttingMap={vectorCuttingMap}
                            drawEdge={drawEdge}
                            drawPosition={drawPosition}
                            onDetailHover={onDetailHover}
                            showRuler={showRuler}
                            rulerCoords={rulerCoords}
                            onRulerCoordsChange={onRulerCoordsChange}
                            rulerLocked={rulerLocked}
                            onRulerPinToggle={onRulerPinToggle}
                        />
                    )}
                </Box>
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                }}>
                    {isLoading && (
                        <CircularProgress size={60} thickness={4}/>
                    )}
                </Box>
                <Pagination
                    size="small"
                    sx={{
                        position: 'absolute',
                        bottom: buttonClose ? 0 : 'auto',
                        top: buttonClose ? undefined : 'calc(100% + 8px)',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        margin: 0,
                        marginBottom: '3px',
                    }}
                    color="primary"
                    variant="outlined"
                    shape="rounded"
                    count={totalPages || 1}
                    page={currentPage}
                    onChange={handlePageChange}
                />
                {buttonClose && (
                    <Button
                        sx={{
                            position: 'absolute',
                            bottom: 0,
                            left: '78%',
                            transform: 'translateX(-50%)',
                            margin: 0,
                            marginBottom: '5px',
                            backgroundColor: (theme) => theme.palette.primary.main,
                        }}
                        onClick={close}
                        variant="contained"
                        color="secondary"
                    >
                        Выйти
                    </Button>
                )}
            </Box>
        );
    }

    return (
        <div>
            <ImageList sx={{
                position: 'absolute',
                top: '46%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: weight,
                height: height,
            }} cols={1}>
                {displayedImages.map((image, index) => (
                    <ImageListItem key={index} onClick={handleImageClick}>
                        <img src={image.src} alt={index}/>
                    </ImageListItem>
                ))}
            </ImageList>
            <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)'
            }}>
                {isLoading && (
                    <CircularProgress size={60} thickness={4}/>
                )}
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    gap: '0.5rem',
                    paddingLeft: '0.5rem',
                    paddingTop: '0.5rem',
                    paddingBottom: '0.2rem',
                    flexWrap: 'wrap',
                }}
            >
                <Pagination size="small" sx={{
                    position: 'absolute',
                    bottom: 0,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    margin: 0,
                    marginBottom: '3px',
                }} color="primary" variant="outlined" shape="rounded" count={totalPages || 1} page={currentPage}
                            onChange={handlePageChange}/>
                {buttonClose && <Button
                    sx={{
                        position: 'absolute',
                        bottom: 0,
                        left: '78%',
                        transform: 'translateX(-50%)',
                        margin: 0,
                        marginBottom: '5px',
                        backgroundColor: (theme) => theme.palette.primary.main,
                    }}
                    onClick={close}
                    variant="contained" color="secondary"
                >Выйти</Button>}
            </Box>
        </div>
    );
};

export default CuttingImageGallery;
